<template>
  <div class="container-fluid max-container">
    <div class="row">
      <Header />
      <section>
        <div class="container">
          <div class="archaic-upgrade-container-fluid">
            <!-- BreadCrumb component starts here -->
            <nav class="mt-4" style="--bs-breadcrumb-divider: '>'" aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item" aria-current="page">
                  <router-link :to="{ name: 'dashboard' }">Home</router-link>
                </li>
                <li class="breadcrumb-item active">Blood Test
                </li>
              </ol>
            </nav>
            <!-- BreadCrumb Component ends here -->
            <!-- Head Box component starts here -->
            <div class="header-box-row-wrapper">
              <div class="row">
                <div class="col-md-9 d-flex flex-column justify-content-center">
                  <div class="left-side-content-blood-row">
                    <h1> {{ $store.getters.profile.profile.name }} Your Blood Test Overview</h1>
                    <p class="card-text text-start mt-4">Your blood test results, and any test we're still processing.</p>
                  </div>
                </div>
                <div class="col-md-3 d-flex flex-column align-items-end justify-content-end">
                  <div class="right-side-blood-test-img">
                    <img :src="BannerDoctor" alt=""/>
                  </div>
                </div>
              </div>
            </div>
            <!-- Head Box component ends here -->
            <!-- Test Cases component starts here -->
            <div v-if="patientStore.patient.tests.length > 0" class="test-case-row">
              <!-- grid component starts here -->
              <div v-for="test in patientStore.patient.tests" :key="test.id">
                <router-link v-if="test.result" :to="{
                    name: 'bloodTestReport',
                    params: { barcode: test.barcode },
                  }" class="test-case-grid-row text-decoration-none text-black">
                  <div>
                    <div class="status-head">
                      <h4><u>{{ test.name }}</u></h4>
                      <div class="light-green bg-light-green">{{ test.instance }} Test</div>
                    </div>
                    <div v-html="test.result.medicalReportSummary" />

                  </div>
                  <div>
                    <p>
                      Completed
                      {{
                    new Date(test.result.date).toLocaleDateString("en-GB")
                  }}
                    </p>
                  </div>
                  <div>
                    <!-- <div class="points">
                      <div>
                        <div class="count-out-of-range">3x</div>
                        <p>Out of Range</p>
                      </div>
                      <div>
                        <div class="count-in-range">8x</div>
                        <p>Normal Range</p>
                      </div>
                    </div> -->

                    <HealthTrafficLights v-if="!test.result.testFailed" :bloodTest="test.result"
                      v-slot="{ inRange, outOfRange }">
                      <div class="points d-flex gap-3">
                        <div class="d-flex justify-content-center align-items-center gap-2">
                          <div class="count-out-of-range"> {{ outOfRange }}x</div>

                          <span>out of range</span>
                        </div>
                        <div class="d-flex justify-content-center align-items-center gap-2">
                          <div class="count-in-range">{{ inRange }}x</div>
                          <span> normal range</span>
                        </div>
                      </div>
                    </HealthTrafficLights>
                  </div>

                  <!-- Was a "Due Date" reminder for the next test, which is no longer sold. The cell keeps the grid's columns. -->
                  <div></div>
                </router-link>
                <div v-else>
                  <div class="test-case-grid-row text-decoration-none text-black">
                    <div>
                      <div class="status-head">
                        <h4><u>{{ test.name }}</u></h4>
                        <div class="light-blue bg-light-blue">{{ test.instance }} Test</div>
                      </div>
                    </div>
                    <div>
                      <p>
                        Activated
                        {{
                    new Date(test.createdAt).toLocaleDateString("en-GB")
                  }}
                      </p>
                    </div>
                    <div>
                      We're currently testing your sample. We'll be in touch when
                      your results are ready
                    </div>
                  </div>
                </div>
                <!-- </router-link> -->
              </div>
              <!-- grid component ends here -->
            </div>
            <div class="row" v-else-if="!loading">
              <!-- Blood tests are no longer sold, so there is nothing to offer here: just say so. -->
              <p class="card-text text-start">You don't have any blood test results.</p>
            </div>
            <!-- Test Cases component ends here -->
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<style>
.cate-list ul {
  padding-left: 0px;
  list-style: none;
  display: flex;
  flex-direction: row;
  gap: 14px;
  flex-wrap: wrap;
}

.cate-list ul li {
  border: 1px solid #d51b5e;
  border-radius: 40px;
  padding: 10px;
  gap: 10px;
  display: flex;
  color: #1b1b1b;
  font-size: 12px;
  text-align: left;
  padding: 10px 20px;
  white-space: nowrap;
  align-items: center;
}

.goal-icon {
  width: 20px;
  filter: invert(20%) sepia(85%) saturate(2287%) hue-rotate(318deg) brightness(99%) contrast(104%);
}

.first-layer {
    width: 210px;
    height: 210px;
    border-radius: 210px;
    /* Result colours from styles/base/resultColors: amber, green, blue. */
    background-color: #E39A1C;
    position: relative;

    label {
      color: #1A1F36;
      font-size: 12px;
      top: 11%;
      left: 50%;
      transform: translate(-50%, -50%);
      position: relative;
    }

    .second-layer {
      background-color: #10A36B;
      height: 160px;
      width: 160px;
      border-radius: 150px;
      bottom: -25px;
      margin: 0px auto;
      position: relative;

      label {
        position: absolute;
        font-size: 12px;
        top: 24%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }

    .third-layer {
      background-color: #154096;
      height: 98px;
      width: 98px;
      border-radius: 150px;
      bottom: 72px;
      margin: 0px auto;
      position: relative;
      z-index: 99;

      label {
        position: absolute;
        font-size: 12px;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: white;
      }
    }
  }

  .upgrade-card {
    .bg-gradient-circle {
        background: url('@/assets/gradient-circle.png') no-repeat;
        background-position: right;
    }

    img {
        max-height: 310px;
    }

    .card-title {
        color: #37F;
        font-size: 14px;
        margin-left: 60px;
        position: relative;

        &::before {
            content: "";
            position: absolute;
            height: 2px;
            width: 50px;
            background-color: #37F;
            left: -60px;
            top: 12px;
        }
    }
}
.right-side-blood-test-img { 
  background : url('@/assets/characters/Ellipse.svg') no-repeat;
  background-position: bottom left;
  background-size: contain; /* Adjust as needed to control the size of the image */
  height: 100%; /* Ensure the height of the element is defined */
  width: 100%; /* Ensure the width of the element is defined */
  img {
    width :70% !important;
 }
}
</style>

<script setup>

import Header from "@/components/header/Header.vue";
import BannerDoctor from "@/assets/characters/blood-test-inspiration-new.png";
import "@/styles/pages/bloodTest.scss";
import HealthTrafficLights from "@/components/HealthTrafficLights.vue";
import { usePatientStore } from "@/store/health/blood";
import { useResultsStore } from "@/store/results";

import { onMounted, ref } from "vue";

const patientStore = usePatientStore();
const resultsStore = useResultsStore();
const loading = ref(true);

function finishLoading() {
  loading.value = false;
}
onMounted(() => {
  Promise.all([patientStore.getPatient()])
    .then(() => resultsStore.setBloodResults(patientStore.patient))
    .catch((e) => {
      if (e.message === "No tests for this patient yet") {
        console.log(e.message);
      }
    })
    .finally(finishLoading);
});
</script>
